import { Box } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import NumberField from "../fields/NumberField";

type SyncFormProps = {
  onSubmit: (...params: any) => void;
  formName?: string;
};

const SyncForm = (props: SyncFormProps) => {
  const { onSubmit, formName } = props;
  return (
    <Form onSubmit={onSubmit} validate={syncValidate}>
      {(props) => (
        <form onSubmit={props.handleSubmit} id={formName}>
          <Box p="5">
            <Field
              name="pages"
              label="How many pages do you want to scrap"
              min={0}
              component={NumberField}
            />
          </Box>
        </form>
      )}
    </Form>
  );
};

export const syncValidate = (value: any) => {
  const errors: any = {};

  if (!value.pages) {
    errors.pages = "Required";
  }

  return errors;
};

export default SyncForm;
